<template>
    <div class="page page--reimbursement layout">
        <div class="layout__header layout__header--reimbursement">
			<img :src="logo" alt="" class="logo--reimbursement">
        </div>
        <div class="layout__body">
			<div class="form">
				<div class="form__content">
					<div class="form__title">查询条件设置</div>
					<div class="form__group">
						<div class="form__label">报销提交日</div>
						<div class="form__select form__select--block">
							<select v-model="type">
								<option value="1">一周</option>
								<option value="2">一个月</option>
								<option value="3">三个月</option>
								<option value="4">六个月</option>
							</select>
						</div>
					</div>
					<div class="form__group">
						<div class="form__label"><div class="form__label--tip">或者</div><div>报销ID（例：130237BN）</div></div>
						<div class="form__input form__input--block">
							<input type="text" v-model="id" placeholder="请输入报销ID搜素">
						</div>
					</div>
				</div>
				<div class="form__btn">
					<a href="javascript:;" class="btn" @click="goReimListPage">搜索</a>
				</div>
			</div>
        </div>
		<div class="mask mask--datetime-picker j_datetime_picker" :data-filed="datetimeFiled" v-show="showPicker">
			<div class="datetime-picker">
				<van-datetime-picker
					v-model="currentDate"
					type="date"
					:formatter="formatter"
					@confirm="setDate"
					@cancel="cancelSetDate"
				/>
			</div>
		</div>
    </div>
</template>
<script>
import API from '@/api.js';
import util from '@/lib/util';
export default {
	name: 'home',
	data () {
		return {
			logo: localStorage.getItem('logo-ee'),
			showPicker: false,
			currentDate: new Date(),
			datetimeFiled: '',
			id: '',
			type: '1', // 选择日期范围 一周 一个月 三个月 六个月
			start_time: '',
			end_time: ''
		};
	},
	computed: {
		startTimeStr () {
			let value = util.formatDate(this.start_time);
			return value;
		},
		endTimeStr () {
			let value = util.formatDate(this.end_time);
			return value;
		}
	},
	methods: {
		formatter (type, value) {
			if (type === 'year') {
				return `${value}年`;
			} else if (type === 'month') {
				return `${value}月`;
			} else if (type === 'day') {
				return `${value}日`;
			}
			return value;
		},
		openDatetimePicker (field) {
			this.datetimeFiled = field;
			this.showPicker = true;
		},
		cancelSetDate () {
			this.datetimeFiled = '';
			this.showPicker = false;
		},
		setDate (value) {
			this[this.datetimeFiled] = value;
			this.showPicker = false;
			this.datetimeFiled = '';
		},
		setWechat () {
			let _self = this;
			API.getWechatAssign().then((res) => {
				let data = res.data.data;
				_self.$wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['hideOptionMenu', 'showOptionMenu']
				});
				_self.$wx.ready(function () {
					_self.$wx.showOptionMenu();
				});
				_self.$wx.showOptionMenu();
			});
		},
		goReimListPage () {
			this.$router.push({
				path: '/reimbursement/list',
				name: 'reimbursement-list',
				params: {
					id: this.id,
					type: this.type
				}
			});
		}
	},
	components: {
	},
	created () {
	},
	mounted () {
	}
};
</script>
